import { Component, OnInit } from "@angular/core";
import { BehaviorSubject } from 'rxjs';

import { BaseControlComponent } from "../base-control/base-control.component";
import { Note } from "../../../common/models/note.model";
import { NoteType } from "../../../common/models/note-type.enum";
import { RetentionPolicy } from "../../../common/models/retention-policy.model";
import { NoteUrgency } from "../../../common/models/note-urgency.enum";
import { NoteRelatedItemType } from "../../../common/models/note_relatedItemType.enum";
import { genId } from "../../../core/services/genId";
import { AuthService } from "../../../services/auth.service";
import { UserIdentity } from "../../../models/user-identity.model";
import { ContextInteractionService } from "../../services/context-interaction.service";

@Component({
    selector: "app-review-comments",
    templateUrl: "review-comments.component.html",
    styleUrls: ["./review-comments.component.scss"],
    standalone: false
})

export class ReviewCommentsComponent extends BaseControlComponent implements OnInit {
    static componentName = "ReviewCommentsComponent";

    processingNote = new BehaviorSubject<boolean>(false);
    processingNote$ = this.processingNote.asObservable();

    storedNotes: any;

    note: Note;
    noteFeedback: string = "";
    activeUser: UserIdentity;

    get noteText(): string {
        if (!this.note) {
            this.note = this.generateNewNote();
        }
        return this.note.text;
    }
    set noteText(text: string) {
        this.note.text = text;
    }

    get noteType(): boolean {
        if (!this.note) {
            this.note = this.generateNewNote();
        }
        return this.note.type === NoteType.Internal;
    }

    set noteType(isInternal: boolean) {
        this.note.type = (isInternal) ? NoteType.Internal : NoteType.General;
    }

    get disableAppend(): boolean {
        return this.noteText.length === 0;
    }

    constructor(public readonly auth: AuthService, public readonly contextService: ContextInteractionService) {
        super(contextService);
    }


    ngOnInit() {
        if (!this.componentData.contextTarget)
            this.componentData.contextTarget = "$.reviewComments";

        if (this.componentData.label && this.componentData.label === "Final Review Comments")
            this.componentData.label = "Review Notes";

        this.activeUser = this.auth.User;
        this.storedNotes = this.getContextData(this.reviewNotesContext);

        if (this.storedNotes === undefined || this.storedNotes === null ||
            (this.storedNotes["visible"] !== undefined && this.storedNotes["visible"] !== null)) {
            this.storedNotes = [];
            this.storeContext(this.storedNotes, this.reviewNotesContext);
        }

        this.note = this.generateNewNote();
    }

    appendComment(e: Event): void {
        if (this.isEdit) return;
        this.storedNotes.push(this.note);
        this.storeContext(this.storedNotes, this.reviewNotesContext);
        this.processingNote.next(true);
        this.flowComponent.promiseSaveContext().then(() => {
            this.noteFeedback = "Note saved.  To view, click the \"View Notes & Timeline\" button and review the \"Review Notes\" tab.";
            this.processingNote.next(false);
            setTimeout(() => {
                this.noteFeedback = "";
            },
                5000);
            this.note = this.generateNewNote();
        },
            (error) => {
                this.noteFeedback = `Error saving note: ${error}`;
                this.processingNote.next(false);
                setTimeout(() => {
                    this.noteFeedback = "";
                },
                    5000);
            });
    }

    generateNewNote(): Note {
        const id = genId();
        return {
            id: id,
            createdDate: new Date(),
            createdById: this.activeUser.id,
            createdBy: this.activeUser.displayName,
            documentType: "Note",
            isDeleted: false,
            noteId: id,
            relatedItemId: (this.flowComponent && this.flowComponent.workflow) ? this.flowComponent.workflow.id : null,
            relatedItemType: NoteRelatedItemType.Workflow,
            text: "",
            retentionPolicy: { id: genId() } as RetentionPolicy,
            noteUrgency: NoteUrgency.LowPriority,
            type: NoteType.General,
            notes: [],
            referenceUri: ""            
        } as Note;
    }
}